import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

import { getExports } from 'services/env';

export async function initDatadog() {
  const {
    ddAppId,
    ddClientId,
    applicationVersion,
    env,
    accountsUrl,
    arkhamApiURL,
    strapiUrl,
    wellzBffURL,
    partnersPayoutURL,
    nvMessagingUrl,
  } = await getExports();

  if (!ddClientId) return;

  const datadogAttributes = {
    clientToken: ddClientId,
    site: 'datadoghq.com',
    service: 'wellzcare-cp-platform-frontend',
    env: env || 'development',
    version: applicationVersion,
  };

  if (ddAppId) {
    datadogRum.init({
      ...datadogAttributes,
      applicationId: ddAppId,
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 0,
      defaultPrivacyLevel: 'mask-user-input',
      allowedTracingUrls: [
        arkhamApiURL,
        accountsUrl,
        strapiUrl,
        wellzBffURL,
        partnersPayoutURL,
        nvMessagingUrl,
      ],
    });

    datadogRum.startSessionReplayRecording();
  }

  datadogLogs.init({
    ...datadogAttributes,
    forwardErrorsToLogs: true,
  });
}
